import "@/helpers/turbo"
import { register } from "../helpers/stimulus"

import { setupSearchBar } from "@/components/search_bar"

import CarouselController from "../controllers/carousel_controller"
import DisclosureItemController from "../controllers/disclosure_item_controller"
import HideOnScrollController from "../controllers/hide_on_scroll_controller"
import LoaderController from "../controllers/loader_controller"
import ModalTriggerController from "../controllers/modal_trigger_controller"
import SnackBarController from "../controllers/snackbar_controller"
import WishlistController from "../controllers/wishlist_controller"

import FiltersModalController from "../controllers/search/filters_modal_controller"
import MapMarkerCarouselController from "../controllers/search/map_marker_carousel_controller"
import PriceFilterController from "../controllers/search/price_filter_controller"
import PriceRangeController from "../controllers/search/price_range_controller"
import ProgressBarController from "../controllers/search/progress_bar_controller"
import SearchFiltersController from "../controllers/search/search_filters_controller"
import SearchMapController from "../controllers/search/search_map_controller"
import SearchResultsController from "../controllers/search/search_results_controller"
import BloomreachSearchController from "../controllers/tracking/bloomreach_search_controller"

import { ENTRY, prefetchEntry } from "@/helpers/prefetch"

const prefetchVenues = (): void => {
  document.addEventListener("DOMContentLoaded", () => prefetchEntry(ENTRY.VENUES))
}

const setupStimulus = (): void => {
  register("bloomreach-search", BloomreachSearchController)
  register("carousel", CarouselController)
  register("filters-modal-trigger", ModalTriggerController)
  register("hide-on-scroll", HideOnScrollController)
  register("loader", LoaderController)
  register("map-marker-carousel", MapMarkerCarouselController)
  register("price-filter", PriceFilterController)
  register("price-range", PriceRangeController)
  register("progress-bar", ProgressBarController)
  register("search-filters", SearchFiltersController)
  register("search-map", SearchMapController)
  register("search-results", SearchResultsController)
  register("snackbar", SnackBarController)
  register("wishlist", WishlistController)
  register("disclosure-item", DisclosureItemController)
  register("filters-modal", FiltersModalController)
}

setupSearchBar()
setupStimulus()
prefetchVenues()
